document.addEventListener("DOMContentLoaded", () => {
  $('.section-compre-look').each(function() {
    const $section = $(this); // vitrine atual
    $section.find('.slick-vitrine').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $section.find('.prev-arrow'),
      nextArrow: $section.find('.next-arrow'),
      dots: false,
    });
  });
  function setupModalToggle() {

    const buttons = document.querySelectorAll(".look-animation");

    buttons.forEach((button) => {

        const modalProduto = button.querySelector(".modal-produto-look");

        if (!modalProduto) return;

        // ABRIR / FECHAR
        button.addEventListener("click", function (e) {

            e.stopPropagation();

            const isActive = modalProduto.classList.contains("active");

            // FECHA TODOS
            document.querySelectorAll(".modal-produto-look").forEach((modal) => {
                modal.classList.remove("active");
            });

            // ABRE O ATUAL
            if (!isActive) {
                modalProduto.classList.add("active");
            }

        });

    });

    // FECHAR AO CLICAR FORA
    document.addEventListener("click", function (e) {

        document.querySelectorAll(".look-animation").forEach((button) => {

            const modalProduto = button.querySelector(".modal-produto-look");

            if (!button.contains(e.target)) {
                modalProduto?.classList.remove("active");
            }

        });

    });

    // BOTÃO FECHAR
    document.querySelectorAll(".btn-fechar-modal").forEach((btn) => {

        btn.addEventListener("click", function (e) {

            e.stopPropagation();

            const modal = btn.closest(".modal-produto-look");

            modal?.classList.remove("active");

        });

    });

}

setupModalToggle();
});